export default __webpack_public_path__ + "static/media/logo.ef99cb3a.svg";